import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {
  goToPage,
  setPercent,
  setEmailError,
  setPhoneNumberError,
  MovingApartmentExecution,
  setSelectedInvoicingDeliveryType,
  setInvoicingDeliveryDetails,
  setFooterMassage,
  report,
  setContactDetails,
} from '../MovingBlockSlice';
import ProgressLine from '../Partials/ProgressLine/ProgressLine';
import GenericDetails from '../Partials/GenericDetails/GenericDetails';
import UpdateEmail from '../Partials/UpdateEmail/UpdateEmail';
import MovingFooter from '../Partials/MovingFooter/MovingFooter';
import CollaborationApproval from '../Partials/CollaborationApproval/CollaborationApproval';
import {gtag4} from '../../../../utilities/analytics/tracking';
import {dwhThirdPartyConsentCheckboxDisplay} from '../../ChangePricePlanBlock/reports/dwhReports';

const SummaryPage = (props) => {
  useEffect(() => {
    window.scrollTo(0, 0);
    props.setPercent(85);
    if (props.movingWithTechnician) {
      if (props.pinTechnicianDetails?.isTechnician) {
        gtag4({
          event: 'Moving_Step4_PinTechSummaryPage_S3',
          title: 'כמעט סיימנו ...',
          step: '4',
          action: 'PinTechSummaryPage_S3',
          funnel_name: '1 - MovingWithProducts',
        });
      } else {
        gtag4({
          event: 'Moving_Step4_SummaryPage_S3',
          title: 'כמעט סיימנו ...',
          step: '4',
          action: 'SummaryPage_S3',
          funnel_name: '1 - MovingWithProducts',
        });
      }
      props.report({
        actionType: 'Summary Before Order',
        status: 'Ongoing',
        messageText: 'Summary Page Displayed',
        products: props.products,
        param2: props.fullAddress,
        selectedProducts: props.selectedProducts,
        param4: props.selectedEntry?.infrastructure,
        param5: props.fullDate,
        param6: 'קיבלת מאיתנו 50% הנחה על שירות אינטרנט ו-TV בחשבונית הראשונה',
        param9: props.technicianType,
        param10: props.pinTechnicianDetails?.technicianParams?.addDays ?? '2',
      });
    } else {
      if (props.products?.length != 0) {
        gtag4({
          event: 'Moving_Step3_UpdateAddressPage',
          title: 'עוד רגע מסיימים',
          step: '3',
          action: 'UpdateAddressPage',
          funnel_name: '1 - MovingWithProducts',
        });
      } else {
        gtag4({
          event: 'Moving_Step2_AddressSummaryPage',
          title: 'איזה כיף! השירותים שברשותך לא דורשים טכנאי',
          step: '2',
          action: 'AddressSummaryPage',
          funnel_name: '2 - MovingWithoutProducts',
        });
      }
      props.report({
        actionType: 'Address Update Page',
        status: 'Ongoing',
        messageText: 'Address Update Only Page Displayed',
        products: props.products,
      });
    }

    if (props.isDisplayCollaborationApproval) {
      dwhThirdPartyConsentCheckboxDisplay(
        props.contactDetails.firstName + ' ' + props.contactDetails.lastName,
        props.contactDetails.phone,
        props.userDetails.IDNumber,
        'מעבר דירה',
      );
    }
  }, []);

  function handleBtnClick() {
    if (props.movingWithTechnician) {
      if (props.pinTechnicianDetails?.isTechnician) {
        gtag4({
          event: 'Moving_Step4_PinTechSummaryButton_S3',
          title: 'כמעט סיימנו...',
          button: 'אישור וסיום',
          step: '4',
          action: 'PinTechSummaryButton_S3',
          funnel_name: '1 - MovingWithProducts',
        });
      } else {
        gtag4({
          event: 'Moving_Step4_SummaryButton_S3',
          title: 'כמעט סיימנו...',
          button: 'אישור וסיום',
          step: '4',
          action: 'SummaryButton_S3',
          funnel_name: '1 - MovingWithProducts',
        });
      }
    } else {
      if (props.products?.length != 0) {
        gtag4({
          event: 'Moving_Step3_UpdateAddressButton',
          title: 'עוד רגע מסיימים',
          button: 'אישור וסיום',
          step: '3',
          action: 'UpdateAddressButton',
          funnel_name: '1 - MovingWithProducts',
        });
      } else {
        gtag4({
          event: 'Moving_Step2_AddressSummaryPageButton',
          title: 'איזה כיף! השירותים שברשותך לא דורשים טכנאי',
          button: 'אישור וסיום',
          step: '2',
          action: 'AddressSummaryPageButton',
          funnel_name: '2 - MovingWithoutProducts',
        });
      }
    }

    props.report({
      actionType: 'Summary Before Order',
      status: 'Ongoing',
      messageText: 'Summary Page Button Clicked',
      products: props.products,
      param2: props.fullAddress,
      selectedProducts: props.selectedProducts,
      param4: props.selectedEntry?.infrastructure,
      param5: props.fullDate,
      param6: props.isCollaborationApproval,
      param7: props.email?.value,
      param8: props.contactDetails?.phone,
      param9: props.technicianType,
      param10: props.pinTechnicianDetails?.technicianParams?.addDays ?? '2',
    });
    props.setFooterMassage('');
    if (props.pinTechnicianDetails?.isTechnician) {
      props.goToPage('truckAnimationPage');
      props.MovingApartmentExecution();
    } else {
      if (props.movingWithTechnician && props.invoicingDeliveryType == '' && !props.email?.value) {
        props.setEmailError(' ');
        props.setPhoneNumberError(' ');
        props.setFooterMassage('יש לבחור לאן לשלוח את הסיכום');
        const element = document.getElementById('email');
        element.scrollIntoView();
        return;
      }

      if (!props.movingWithTechnician) {
        if (!props.email?.value) {
          props.setEmailError('אנא הזן את כתובת המייל');
        } else {
          if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(props.email?.value)) {
            props.setEmailError('');
            props.goToPage('truckAnimationPage');
            props.report({
              actionType: 'Address Update Page',
              status: 'Ongoing',
              messageText: 'Address Update Only Button Clicked',
              products: props.products,
              param2: props.fullAddress,
              param4: props.selectedEntry?.infrastructure,
              param6: props.isCollaborationApproval,
              param7: props.email?.value,
            });
            props.MovingApartmentExecution();
          } else {
            props.setEmailError('נא להזין כתובת מייל תקינה');
          }
        }
      } else {
        if (props.invoicingDeliveryType == 'email') {
          if (!props.email?.value) {
            props.setEmailError('אנא הזן את כתובת המייל');
          } else {
            if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(props.email?.value)) {
              props.setEmailError('');
              props.goToPage('truckAnimationPage');
              props.MovingApartmentExecution();
            } else {
              props.setEmailError('נא להזין כתובת מייל תקינה');
            }
          }
        } else {
          if (!props.contactDetails.phone) {
            props.setPhoneNumberError('אנא הזן את מספר הטלפון');
          } else {
            if (
              /^[(]{0,1}[0-9]{3}[)]{0,1}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}$/.test(props.contactDetails.phone) ||
              (/^0[0-9]{8}$/.test(props.contactDetails.phone) && props.contactDetails.phone.length === 9)
            ) {
              props.setPhoneNumberError('');
              props.goToPage('truckAnimationPage');
              props.MovingApartmentExecution();
            } else {
              props.setPhoneNumberError('נא להזין מספר טלפון תקין');
            }
          }
        }
      }
    }
  }

  const genericTitle = () => {
    let title = '';
    let subTitle = '';
    let text = ''; // Define the sub variable

    if (props.movingWithTechnician) {
      title = (
        <>
          לפני שמסיימים,
          <br />
          רק נראה שהכל מדויק
        </>
      );
      subTitle = '';
    } else {
      if (props.products?.length === 0) {
        title = 'איזה כיף! השירותים שברשותך לא דורשים טכנאי';
        subTitle = 'אם בכל זאת יש לך שירות כזה, כדאי לבדוק אם הוא רשום על לקוח אחר';
        text = `${props.fullAddress} ${props.selectedEntry?.entry && 'כניסה: ' + props.selectedEntry?.entry}`;
      } else {
        title = 'עוד רגע ואנחנו מסיימים';
        subTitle = 'השירותים שבחרת לא דורשים טכנאי, נשאר רק לעדכן את הכתובת החדשה';
        text = `${props.fullAddress} ${props.selectedEntry?.entry && 'כניסה: ' + props.selectedEntry?.entry}`;
      }
    }

    return (
      <div className='title-container'>
        <h1 className='title'>{title}</h1>
        <div className='sub-title'>{subTitle}</div>
        <div className='text'>{text}</div>
      </div>
    );
  };

  function handleSetSelectedInvoicingDeliveryType(type) {
    props.setSelectedInvoicingDeliveryType(type);
  }

  function handleSetInvoicingDeliveryDetails(type, value) {
    props.setInvoicingDeliveryDetails({type: type, value: value});
  }

  function handleOnBtnClickAddContactDetails(contactDetails) {
    props.setContactDetails({
      firstName: contactDetails?.firstName?.value,
      lastName: contactDetails?.lastName?.value,
      phone: contactDetails.phone?.value,
    });
  }

  return (
    <div className='summary-page'>
      <ProgressLine percent={props.percent} />
      {genericTitle()}
      <GenericDetails fullAddress={props.fullAddress} onBtnClickAddContactDetails={handleOnBtnClickAddContactDetails} />

      {!props.pinTechnicianDetails?.isTechnician && (
        <UpdateEmail
          context={props.context}
          termsLink={props.termsLink}
          primaryEmail={props.primaryEmail}
          privatePolicyLink={props.privatePolicyLink}
          setSelectedInvoicingDeliveryType={handleSetSelectedInvoicingDeliveryType}
          setInvoicingDeliveryDetails={handleSetInvoicingDeliveryDetails}
          email={props.email}
          phoneNumber={props.contactDetails.phone}
        />
      )}

      {props.page === 'summaryPage' && props.isDisplayCollaborationApproval && (
        <CollaborationApproval isCollaborationApproval={props.isCollaborationApproval} />
      )}

      <MovingFooter onBtnClick={handleBtnClick} btnText={'אישור וסיום'} />
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    page: state.movingBlock.movingApartmentData.page,
    percent: state.movingBlock.movingApartmentData.percent,
    email: state.movingBlock.movingApartmentData.email,
    phoneNumber: state.movingBlock.movingApartmentData.phoneNumber,
    fullAddress: state.movingBlock.movingApartmentData.address?.fullAddress,
    products: state.movingBlock.movingApartmentData.products,
    movingWithTechnician: state.movingBlock.movingApartmentData.movingWithTechnician,
    isCollaborationApproval: state.movingBlock.movingApartmentData.isCollaborationApproval,
    isDisplayCollaborationApproval: state.movingBlock.movingApartmentData.isDisplayCollaborationApproval,
    termsLink: state.movingBlock.movingEpiData.termsLink?.value,
    privatePolicyLink: state.movingBlock.movingEpiData.privatePolicyLink?.value,
    invoicingDeliveryType: state.movingBlock.movingApartmentData.invoicingDeliveryType,
    fullDate: state.movingBlock.movingApartmentData.technicianData?.selectedTechnicianTimeSlot?.fullDate,
    selectedProducts: state.movingBlock.movingApartmentData.selectedProducts,
    selectedEntry: state.movingBlock.movingApartmentData.address?.selectedEntry,
    contactDetails: state.movingBlock.movingApartmentData.contactDetails,
    pinTechnicianDetails: state.movingBlock.movingApartmentData.pinTechnicianDetails,
    technicianType: state.movingBlock.movingApartmentData.technicianType,
    userDetails: state.authentication.loginData.userDetails,
    primaryEmail: state.movingBlock.movingApartmentData.primaryEmail,
  };
};

const mapDispatchToProps = {
  goToPage,
  setPercent,
  setEmailError,
  setFooterMassage,
  setPhoneNumberError,
  MovingApartmentExecution,
  setSelectedInvoicingDeliveryType,
  setInvoicingDeliveryDetails,
  setContactDetails,
  report,
};

export default connect(mapStateToProps, mapDispatchToProps)(SummaryPage);
